import type { CSSProperties } from 'react';
import { SCENES } from './planetSections';

interface OrbitRailProps {
  activeIndex: number;
  hidden?: boolean;
}

export function OrbitRail({ activeIndex, hidden = false }: OrbitRailProps) {
  const jumpTo = (index: number) => {
    if (typeof window === 'undefined') return;
    const scene = SCENES[index];
    if (!scene) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, scene.start * max + 1),
      behavior: reduced ? 'auto' : 'smooth',
    });
  };

  return (
    <nav
      className={['orbit-rail', hidden ? 'is-hidden' : ''].filter(Boolean).join(' ')}
      aria-label="Planet chapters"
    >
      <span className="orbit-rail__arc" aria-hidden="true" />
      {SCENES.map((scene, index) => {
        const delta = index - activeIndex;
        const distance = Math.abs(delta);
        const style = {
          '--rail-y': `${delta * 42}px`,
          '--rail-x': `${Math.pow(distance, 1.35) * 7}px`,
          '--rail-scale': Math.max(0.62, 1 - distance * 0.11),
          '--rail-opacity': distance > 3 ? 0 : Math.max(0.22, 1 - distance * 0.23),
        } as CSSProperties;
        return (
          <button
            key={scene.key}
            type="button"
            className={['orbit-rail__item', index === activeIndex ? 'is-active' : '']
              .filter(Boolean)
              .join(' ')}
            style={style}
            onClick={() => jumpTo(index)}
            aria-current={index === activeIndex ? 'step' : undefined}
            aria-label={`Go to ${scene.name}`}
          >
            <span className="orbit-rail__tick" aria-hidden="true" />
            <span className="orbit-rail__index">{String(index).padStart(2, '0')}</span>
            <span className="orbit-rail__name">{scene.name}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default OrbitRail;
